module.exports = __webpack_public_path__ + "static/vinyard3-8f00331ac1dee575fa59607f6f7de2f1.jpg";